import React, { useState, useEffect } from 'react';
import MarqueeComponent from "./marquee.jsx";
import ContactForm from './contact-form.jsx';


const Packaging = () => {
  const data = {
    banner: {
      link: "/assets/img/product-banner/display.jpg",
      linkmobile: "/assets/img/product-banner/display-mobile.jpg"
    },
    marqueeWords: [
      { title: "Displays " },
      { title: "Pósters" },
      { title: "Banners" },
      { title: "Telas publicitarias" },
      { title: "Pendones" },
      { title: "Banderas" },
    ],
    mailerbannerproduct: {
      image: "assets/img/display/mailer.png",
      subtitle: "Displays y visual merchandising ",
      highlight: "que harán que tu producto vuele",
      description: `Creamos displays y materiales visuales que destacan tu marca
        con impacto e innovación.  
      <strong class="strong">Desde pósters y banners hasta telas
        publicitarias y displays,</strong> 
        diseñamos soluciones que garantizan
        que tu producto sobresalga en cualquier espacio.`,
      extratext: "En Moti Digital lo hacemos posible,",
      extrahighlight: "solicita tu cotización:"
    },
    sliderimage: {
      image1: "assets/img/display/1.png",
      image2: "assets/img/display/2.png",
      image3: "assets/img/display/3.png",
      image4: "assets/img/display/4.png",
      image5: "assets/img/display/5.png",
      image5: "assets/img/display/6.png",
      image7: "assets/img/display/7.png",
      image8: "assets/img/display/8.png",
    },
    faqData: [
      {
        question: "¿Qué tipos de displays ofrecen?",
        icon: "+"
      },
      {
        question: "¿Qué es el visual merchandising?",
        icon: "+"
      },
      {
        question: "¿Ofrecen servicios de diseño?",
        icon: "+"
      },
      {
        question: "¿Los materiales son eco-friendly?",
        icon: "+"
      },
      {
        question: "¿Puedo poner dato variable en mi visual merchandising?",
        icon: "+"
      }
    ],
    contact: {
      tel: "33 2106 0067",
      email: "jcervantes@motidigital.com"
    },
    options: {
      title: 'Tu producto está listo, pero <strong class="strong">¿ya destaca?</strong>',
      head:'AYÚDALO A BRILLAR CON <strong class="strong">VISUAL MERCHANDISING</strong>',
      1: {
        description: "• Etiquetas con dato variable\n• Pósters con promociones\n• Stickers llamativos\n• Invitaciones para influencers\n• Flyers y brochures\n• Postales y tarjetas",
        },
      2: {
        description: "• Señalética para tu tienda\n• Displays de acrílico o cartón\n• Glorificadores personalizados\n• Papel de regalo para packaging\n• Acrílicos decorativos\n• Papelería personalizada",
        },
    },

  };
  

  const images = [
    data.sliderimage.image1,
    data.sliderimage.image2,
    data.sliderimage.image3,
    data.sliderimage.image4,
    data.sliderimage.image5,
    data.sliderimage.image7,
    data.sliderimage.image8,
  ];

  const [startIndex, setStartIndex] = useState(0);
  const itemsToShow = 3;

  const goToNext = () => {
    setStartIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const goToPrevious = () => {
    setStartIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  // Generar imágenes visibles en bloques de 3
  const getVisibleImages = () => {
    const endIndex = (startIndex + itemsToShow) % images.length;
    if (endIndex > startIndex) {
      return images.slice(startIndex, endIndex);
    } else {
      return [...images.slice(startIndex), ...images.slice(0, endIndex)];
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="gran-formato">
      <section>
        <div>
          <img className="product-banner pc" src={data.banner.link} alt="Banner de comercio electrónico" />
          <img className="value-banner-mobile mobile" src={data.banner.linkmobile} alt="Banner de comercio electrónico" />
        </div>
        <MarqueeComponent words={data.marqueeWords} />
      </section>

      <section className="mailerbannerproduct">
        <div className="-product-mailer-content">
          <img
            className="product-banner pc"
            src={data.mailerbannerproduct.image}
            alt="Banner de comercio electrónico"
          />
          <div className="product-text-wraper">
            <h1 className="product-contact-title">
              {data.mailerbannerproduct.subtitle}
              <span className="product-highlight">
                {data.mailerbannerproduct.highlight}
              </span>
            </h1>
            <img src="assets/img/home-page/ecommerce/dots-moti.png" alt="dots moti" className="dots-moti" />
            <p
              className="product-description"
              dangerouslySetInnerHTML={{ __html: data.mailerbannerproduct.description }}
            ></p>
            <h3>
              {data.mailerbannerproduct.extratext}
              <strong className='strong'>{data.mailerbannerproduct.extrahighlight}</strong>
            </h3>
            <ContactForm />
          </div>
        </div>
      </section>

      <section className="carousel-section">
        <h2 class="carousel-title">Displays y Visual Merchandising
          <img src="assets/img/home-page/ecommerce/logo-dots.png" class="logo+dots" />
        </h2>
        <div className="carousel-container" style={{ display: 'flex', alignItems: 'center' }}>
          <button className="carousel-arrow left" onClick={goToPrevious}>
            &#8249;
          </button>
          <div className="carousel" style={{ display: 'flex', overflow: 'hidden' }}>
            {getVisibleImages().map((image, index) => (
              <div className='img-container-carousel'
                key={index}
                style={{
                  flex: '0 0 33.33%',
                  textAlign: 'center',
                  opacity: index === 1 ? 1 : 0.6,
                  transform: index === 1 ? 'scale(1.1)' : 'scale(1)'
                }}
              >
                <img
                  src={image}
                  alt={`Product ${index}`}
                  style={{ width: '100%', maxHeight: '19rem' }}
                />
              </div>
            ))}
          </div>
          <button className="carousel-arrow right" onClick={goToNext}>
            &#8250;
          </button>
        </div>
      </section>

      <section className="options-product">
        <h3 dangerouslySetInnerHTML={{ __html: data.options.title }}></h3>
        <img src="assets/img/home-page/ecommerce/dots-moti.png" alt="dots moti" className="dots-moti" />
        <h3 dangerouslySetInnerHTML={{ __html: data.options.head }}></h3>
        <div className="options-container">
          <div className="option w-30">
            <p className='options-description'>{data.options[1].description}</p>
          </div>
          <div className="option w-30">
            <p className='options-description'>{data.options[2].description}</p>
          </div>
        </div>
      </section>
      {/* Sección de Preguntas Frecuentes */}
      <section className="faq-section">
        <div className="faq-wraper">
          <div className="faq-title">
            <h3>Preguntas <span>frecuentes</span></h3>
            <img src="assets/img/home-page/ecommerce/dots-moti.png" alt="dots moti" className="dots-moti" />
          </div>
          <div className="faq-contact">
            <p className="faq-tittle">¿Tienes más preguntas?</p>
            <p className="contact-subtitle">No dudes en contactarnos para más información.</p>
            <div className="contact-info">
              <button className="product-contact-button">
                <span className="product-contact-text">{data.contact.tel}</span>
              </button>
              <div className="product-contact-button">
                <span>{data.contact.email}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="faq-container">
          {data.faqData.map((item, index) => (
            <div key={index} className="faq-item">
              <p>{item.question}</p>
              <span className="faq-icon">{item.icon}</span>
            </div>
          ))}
        </div>
      </section>

    </div>
  );
};

export default Packaging;
